<ef-loading [loading]="IsLoading"></ef-loading>
<div style="display: flex">
    <p-dialog header="Are you sure?" [(visible)]="showAreYouSure" [maximizable]="false" [closable]="false"
        [closeOnEscape]="false">
        <h3>
            This change will override the existing PTO policy assigned to the
            user.
        </h3>
        <ng-template #footer>
            <button type="button" pButton icon="pi pi-check" (click)="confirmSave()" label="Confirm"
                class="p-button-text p-button-success"></button>
            <button type="button" pButton (click)="cancelSave()" icon="pi pi-times" label="Cancel"
                class="p-button-text p-button-danger"></button>
        </ng-template>
    </p-dialog>
</div>
<div style="display: flex">
    <p-dialog header="Are you sure?" [(visible)]="displayAreYouSure" [maximizable]="false" [closable]="false"
        [closeOnEscape]="false">
        <h3>
            This will recalculate all leave accruals within the date range
            {{ moment(this.PPS).format('MM/DD/YYYY') }} -
            {{ moment(this.PPE).format('MM/DD/YYYY') }}?
        </h3>
        <ng-template #footer>
            <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="areYouSureCancelled()"
                class="p-button-text p-button-danger"></button>
            <button type="button" pButton label="Confirm" icon="pi pi-check" (click)="areYouSureConfirmed()"
                class="p-button-text p-button-success"></button>
        </ng-template>
    </p-dialog>
</div>
<div class="card gap-2">
    <p-accordion
        [multiple]="true"
        [(activeIndex)]="activeAccordionIndexes"
        (onOpen)="onAccordionToggle(true)"
        (onClose)="onAccordionToggle(false)">
        <p-accordionTab
            header="Current Leave Summary"
            [selected]="true"
            (onOpen)="onAccordionToggle(true)"
            (onClose)="onAccordionToggle(false)">
        <p-toolbar>
            <label style="
                        font-weight: normal;
                        font-size: 14px;
                        padding-bottom: 0px;
                        margin-bottom: 0px;
                    " for="lagdays">
                {{ lagDaysLabel }}
            </label>
            <input type="text" pInputText [(ngModel)]="this.lagDaysValue" id="lagdays"
                style="width: 4rem; margin-right: 0.5rem" />
            <button pButton pRipple class="p-button-secondary" icon="pi pi-pencil" label="Update Lag Days"
                (click)="onUpdateLagDaysClicked()"></button>
            <p-message *ngIf="lagDaysErrorMessage != null" severity="error" [text]="lagDaysErrorMessage"></p-message>
            <!-- <div style="padding-left: 1vw">
                <ef-column-search [elements]="currentLeaveSummaryElements"></ef-column-search>
            </div> -->
        </p-toolbar>
        <p-table stripedRows #SummaryTable selectionMode="single" [style]="{ 'max-width': '100%' }"
            (onRowSelect)="onEmployeeSelected($event)" [value]="this.summary" [scrollHeight]="tabHeight"
            [scrollable]="true" editMode="row" (onEditInit_Summary)="onEditInit_Summary($event)"
            (onRowEditSave_Summary)="onRowEditSave_Summary($event)" dataKey="EmployeeListID" [virtualScroll]="true" [rows]="30">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="17" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #header>
                <tr>
                    <!-- Edit -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                    <!-- Status -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                        <i class="pi pi-exclamation-circle" title="Status"></i>
                    </th>
                    <!-- Employee -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="EmployeeName">
                        Employee
                        <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="EmployeeName" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" virtualScroll="true" itemSize="30"
                                    [options]="this.summaryNameFilterSelectItem" [filter]="true" styleClass="w-full"
                                    [ngModel]="value" (ngModelChange)="filter($event)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Hire Date -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="HireDate">
                        Hire Date
                        <p-sortIcon field="HireDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Release Date -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="ReleaseDate">
                        Release Date
                        <p-sortIcon field="ReleaseDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Policy Title -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="PolicyTitle">
                        Policy Title
                        <p-sortIcon field="PolicyTitle" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- QB Available -->
                    <th *ngIf="this.usingIntuitPayroll == true" pSortableColumn="QBEmplHoursAvailable">
                        QB Available
                        <p-sortIcon field="QBEmplHoursAvailable" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- QB Taken -->
                    <th *ngIf="this.usingIntuitPayroll == true" pSortableColumn="QBEmplHoursUsed">
                        QB Taken
                        <p-sortIcon field="QBEmplHoursUsed" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Vac Available -->
                    <th pSortableColumn="Vac_Available">
                        VAC FY Available
                        <p-sortIcon field="Vac_Available" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Accrued -->
                    <th pSortableColumn="Vac_HoursEarned">
                        VAC FY Accrued
                        <p-sortIcon field="Vac_HoursEarned" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Taken -->
                    <th pSortableColumn="Vac_HoursTaken">
                        VAC FY Taken
                        <p-sortIcon field="Vac_HoursTaken" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Carryover -->
                    <th pSortableColumn="Vac_Carryover">
                        VAC Carryover
                        <p-sortIcon field="Vac_Carryover" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Accrual Period -->
                    <th pSortableColumn="Vac_Accrualperiod">
                        VAC Accrual Period
                        <p-sortIcon field="Vac_Accrualperiod" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="Vac_Accrualperiod" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                    [options]="summaryVacPeriodFilterSelectItem" [filter]="true" styleClass="w-full"
                                    [ngModel]="value" (ngModelChange)="filter($event)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Accrual Value -->
                    <th pSortableColumn="Vac_Accrualperiodvalue">
                        VAC Accrual Value
                        <p-sortIcon field="Vac_Accrualperiodvalue" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Max Available -->
                    <th pSortableColumn="Vac_HoursMax">
                        VAC Max Available
                        <p-sortIcon field="Vac_HoursMax" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>

                    <th class="separator-cell"></th>

                    <!-- QB Available -->
                    <th *ngIf="this.usingIntuitPayroll == true" pSortableColumn="QBEmplSickHoursAvailable">
                        QB Available
                        <p-sortIcon field="QBEmplSickHoursAvailable" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- QB Taken -->
                    <th *ngIf="this.usingIntuitPayroll == true" pSortableColumn="QBEmplSickHoursUsed">
                        QB Taken
                        <p-sortIcon field="QBEmplSickHoursUsed" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Sick Available -->
                    <th pSortableColumn="Sick_Available">
                        SICK FY Available
                        <p-sortIcon field="Sick_Available" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Accrued -->
                    <th pSortableColumn="Sick_HoursEarned">
                        SICK FY Accrued
                        <p-sortIcon field="Sick_HoursEarned" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- FY Taken -->
                    <th pSortableColumn="Sick_HoursTaken">
                        SICK FY Taken
                        <p-sortIcon field="Sick_HoursTaken" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Carryover -->
                    <th pSortableColumn="Sick_Carryover">
                        SICK Carryover
                        <p-sortIcon field="Sick_Carryover" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Accural Period -->
                    <th pSortableColumn="Sick_Accrualperiod">
                        SICK Accural Period
                        <p-sortIcon field="Sick_Accrualperiod" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="Sick_Accrualperiod" matchMode="in" display="menu"
                            [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                    [options]="summarySickPeriodFilterSelectItem" [filter]="true" styleClass="w-full"
                                    [ngModel]="value" (ngModelChange)="filter($event)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Accrual Value -->
                    <th pSortableColumn="Sick_Accrualperiodvalue">
                        SICK Accrual Value
                        <p-sortIcon field="Sick_Accrualperiodvalue" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Max Available -->
                    <th pSortableColumn="Sick_HoursMax">
                        SICK Max Available
                        <p-sortIcon field="Sick_HoursMax" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template #body let-summary let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="summary" data-id="row-{{ summary.EmployeeListID }}">
                    <!-- Edit -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                        <button *ngIf="
                                                !editing &&
                                                (!editing_Summary?.EmployeeListID ||
                                                    !editing_Summary?.EmployeeListID ===
                                                        summary?.EmployeeListID)
                                            " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit_Summary(summary)" class="p-button-rounded p-button-text"
                            title="Edit"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave_Summary(summary)"
                            class="p-button-rounded p-button-text p-button-success"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="
                                                onRowEditCancel_Summary(summary, ri)
                                            " class="p-button-rounded p-button-text p-button-danger"></button>
                    </td>
                    <!-- Status -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                        <div style="height: 2em; align-self: center" (click)="onStatusClick(summary)">
                            <ef-status-icon [status]="
                                                    summary?.Status?.StatusCode
                                                " [message]="summary?.Status?.Message"></ef-status-icon>
                        </div>
                    </td>
                    <!-- Employee -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <label [title]="summary.EmployeeName">{{
                            summary.EmployeeName
                            }}</label>
                    </td>
                    <!-- Hire Date -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <label *ngIf="summary.HireDate != null" [title]="summary.HireDate">{{
                            moment(summary.HireDate).format(
                            'MM/DD/YYYY'
                            )
                            }}</label>
                    </td>
                    <!-- Release Date -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <label *ngIf="summary.ReleaseDate != null" [title]="summary.ReleaseDate">{{
                            moment(summary.ReleaseDate).format(
                            'MM/DD/YYYY'
                            )
                            }}</label>
                    </td>
                    <!-- Policy Title -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <label [title]="summary.PolicyTitle">
                            <a uiSref="ptopolicy">
                                {{ summary.PolicyTitle }}
                            </a>
                        </label>
                    </td>
                    <!-- QB Available -->
                    <td *ngIf="this.usingIntuitPayroll == true">
                        <label>{{
                            summary.QBEmplHoursAvailable
                            }}</label>
                    </td>
                    <!-- QB Taken -->
                    <td *ngIf="this.usingIntuitPayroll == true">
                        <label>{{ summary.QBEmplHoursUsed }}</label>
                    </td>
                    <!-- FY Vac Available -->
                    <td>
                        <label>{{ summary.Vac_Available }}</label>
                    </td>
                    <!-- FY Accrued -->
                    <td>
                        <label>{{ summary.Vac_HoursEarned }}</label>
                    </td>
                    <!-- FY Taken -->
                    <td>
                        <label>{{ summary.Vac_HoursTaken }}</label>
                    </td>
                    <!-- Carryover -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        summary.Vac_Carryover
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ summary.Vac_Carryover }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Accrual Period -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <div *ngIf="
                                                            accrualPeriodsSelectItems as items
                                                        ">
                                        <ef-dropdown [disabled]="summary.PolicyTitle != null ? true : false"
                                            [items]="items" [rowData]="summary"
                                            property="Vac_Accrualperiod"></ef-dropdown>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <div *ngIf="
                                                            summary.Vac_Accrualperiod !=
                                                            null
                                                        ">
                                        {{
                                        summary.Vac_Accrualperiod
                                        }}
                                    </div>
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Vac_Accrualperiod
                                }}</label>
                        </div>
                    </td>
                    <!-- Accrual Value -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input [disabled]="summary.PolicyTitle != null ? true : false" pInputText
                                        type="text" [(ngModel)]="
                                                            summary.Vac_Accrualperiodvalue
                                                        " />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    summary.Vac_Accrualperiodvalue
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Vac_Accrualperiodvalue
                                }}</label>
                        </div>
                    </td>
                    <!-- Max Available -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="
                                                            summary.Vac_HoursMax
                                                        " />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ summary.Vac_HoursMax }}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Vac_HoursMax
                                }}</label>
                        </div>
                    </td>

                    <td class="separator-cell"></td>

                    <!-- QB Available -->
                    <td *ngIf="this.usingIntuitPayroll == true">
                        <label>{{
                            summary.QBEmplSickHoursAvailable
                            }}</label>
                        <!-- QB Taken -->
                    </td>
                    <td *ngIf="this.usingIntuitPayroll == true">
                        <label>{{
                            summary.QBEmplSickHoursUsed
                            }}</label>
                    </td>
                    <!-- FY Sick Available -->
                    <td>
                        <label>{{ summary.Sick_Available }}</label>
                    </td>
                    <!-- FY Accrued -->
                    <td>
                        <label>{{
                            summary.Sick_HoursEarned
                            }}</label>
                    </td>
                    <!-- FY Taken -->
                    <td>
                        <label>{{ summary.Sick_HoursTaken }}</label>
                    </td>
                    <!-- Carryover -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        summary.Sick_Carryover
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ summary.Sick_Carryover }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Accural Period -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <div *ngIf="
                                                            accrualPeriodsSelectItems as items
                                                        ">
                                        <ef-dropdown [items]="items" [rowData]="summary"
                                            property="Sick_Accrualperiod"></ef-dropdown>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <div *ngIf="
                                                            summary.Sick_Accrualperiod !=
                                                            null
                                                        ">
                                        {{
                                        summary.Sick_Accrualperiod
                                        }}
                                    </div>
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Sick_Accrualperiod
                                }}</label>
                        </div>
                    </td>
                    <!-- Accrual Value -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="
                                                            summary.Sick_Accrualperiodvalue
                                                        " />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{
                                    summary.Sick_Accrualperiodvalue
                                    }}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Sick_Accrualperiodvalue
                                }}</label>
                        </div>
                    </td>
                    <!-- Max Available -->
                    <td>
                        <div *ngIf="this.usingIntuitPayroll == false">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="
                                                            summary.Sick_HoursMax
                                                        " />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ summary.Sick_HoursMax }}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                        <div *ngIf="this.usingIntuitPayroll == true">
                            <label>{{
                                summary.Sick_HoursMax
                                }}</label>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </p-accordionTab>
        <p-accordionTab
            header="Manage Leave History"
            [selected]="false"
            (onOpen)="onAccordionToggle(true)"
            (onClose)="onAccordionToggle(false)">
        <p-toolbar>
            <button type="button" pButton pRipple icon="pi pi-download" (click)="LATable.exportCSV()"
                class="p-button-secondary" style="margin-right: 2em !important" pTooltip="Download"
                tooltipPosition="bottom"></button>
            <form [formGroup]="dateRangeFormGroup" #dateRange="ngForm" id="dateRange">
                <p-floatLabel variant="on">
                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                        [maxDate]="this.prevPayPeriodEnd" selectionMode="range" appendTo="body" [showIcon]="false"
                        id="laDates" formControlName="dateRange">
                    </p-datepicker>
                    <label for="float-dd">Select Pay Period(s) </label>
                </p-floatLabel>
            </form>
            <p-floatLabel variant="on">
                <p-multiSelect styleClass="w-12rem" [options]="historyUsersSelectItem" [filter]="true" appendTo="body"
                    maxSelectedLabels="1" selectedItemsLabel="{0} users selected" (onChange)="
                                    onChangeUser($event)
                                ">
                </p-multiSelect>
                <label for="float-dd">Select User(s) </label>
            </p-floatLabel>

            <div class="flex items-center">
                <p-checkbox #hideZero class="ef-checkbox" binary="true" data-toggle="tooltip" data-placement="top"
                    title="Hide zero accrual records" (onChange)="hideZeroAccrualRecords($event)"
                    [(ngModel)]="hideZeroCbxValue"></p-checkbox>
                <label class="ml-2" for="hideZero">Hide zero accrual records</label>
            </div>
            <div class="flex items-center">
                <p-checkbox #chkAdjustedAccruals class="ef-checkbox" binary="true" data-toggle="tooltip"
                    data-placement="top" title="Show only adjusted accruals"
                    (onChange)="showOnlyAdjustedAccruals($event)" [(ngModel)]="cbxValue"></p-checkbox>
                <label class="ml-2" for="chkAdjustedAccruals">Show only adjusted accruals</label>
            </div>

            <div *ngIf="this.displayRecalcText == true" style="
                                display: flex;
                                justify-content: center;
                                margin-top: 0.5vh;
                            ">
                <p-message severity="success" [text]="this.recalcText">
                </p-message>
            </div>
            <button pButton type="button" label="Recalculate indirect rates" (click)="commitAccrualHistoryAdjustments()"
                class="p-button-secondary" icon="pi pi-upload"
                title="Recalculate indirect rates to reflect manually entered accrual cost overrides"></button>
            <p-progressSpinner *ngIf="working" [style]="{ width: '1.5em', height: '1.5em' }" strokeWidth="8"
                animationDuration="1s"></p-progressSpinner>

            <p-messages *ngIf="
                                showCommitErrorStatusMsg ||
                                showCommitWarningStatusMsg ||
                                showCommitSuccessStatusMsg
                            " [(value)]="commitMsg" [enableService]="false"></p-messages>

            <div>
                <ef-column-search [elements]="leaveHistoryElements"></ef-column-search>
            </div>
        </p-toolbar>
        <p-table stripedRows #LATable id="LATable" [value]="this.filteredHistory" [scrollable]="true" [scrollHeight]="tabHeight"
            editMode="row" (onEditInit)="onEditInit($event)" (onRowEditSave)="onRowEditSave($event)" dataKey="Uniqueid"
            [columns]="cols">
            <!-- <ng-template pTemplate="emptymessage" let-frozen="frozen">
                            <tr>
                                <td style="text-align: center; width: 60%">
                                    <div class="tabulator-placeholder">
                                        <span> {{ frozen ? 'Select user(s) to view Leave History' : '&nbsp;' }} </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template> -->
            <ng-template #header>
                <tr>
                    <!-- Edit -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                    <!-- Status -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                        <i class="pi pi-exclamation-circle" title="Status"></i>
                    </th>
                    <!-- Pay Period Start -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen">
                        Pay Period Start
                        <p-columnFilter field="representative" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" formControlName="PPS" maxSelectedLabels="1"
                                    appendTo="body" [options]="this.historyPPSFilterSelectItem" [filter]="true"
                                    (onChange)="filter($event.value)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Pay Period End -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen">
                        Pay Period End
                        <p-columnFilter field="representative" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" formControlName="PPE" maxSelectedLabels="1"
                                    appendTo="body" [options]="this.historyPPEFilterSelectItem" [filter]="true"
                                    (onChange)="filter($event.value)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Name -->
                    <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="EmployeeName">
                        Name
                        <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Vac Accrual Period -->
                    <th pSortableColumn="VacAccrualPeriod">
                        VAC Accrual Period
                        <p-sortIcon field="VacAccrualPeriod" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="representative" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" formControlName="AccrualPeriod"
                                    maxSelectedLabels="1" appendTo="body"
                                    [options]="this.historyVacPeriodFilterSelectItem" [filter]="true"
                                    (onChange)="filter($event.value)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Hours Setting -->
                    <th pSortableColumn="Vac_HoursSetting">
                        VAC Current Setting
                        <p-sortIcon field="Vac_HoursSetting" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Rate -->
                    <th pSortableColumn="Vac_EarnedRate">
                        VAC Earned Rate
                        <p-sortIcon field="Vac_EarnedRate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Hours Earned -->
                    <th pSortableColumn="Vac_HoursEarned">
                        Hours Earned
                        <p-sortIcon field="Vac_HoursEarned" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Hours Earned Override -->
                    <th pSortableColumn="Vac_HoursEarnedAdjust">
                        VAC Hours Earned Override
                        <p-sortIcon field="Vac_HoursEarnedAdjust" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Cost -->
                    <th pSortableColumn="Vac_EarnedCost">
                        VAC Earned Cost
                        <p-sortIcon field="Vac_EarnedCost" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Cost Override -->
                    <th pSortableColumn="Vac_EarnedCostAdjust">
                        VAC Earned Cost Override
                        <p-sortIcon field="Vac_EarnedCostAdjust" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Taken -->
                    <th pSortableColumn="Vac_HoursTaken">
                        VAC Taken
                        <p-sortIcon field="Vac_HoursTaken" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>

                    <th class="separator-cell"></th>

                    <!-- Sick Accrual Period -->
                    <th pSortableColumn="SickAccrualPeriod">
                        SICK Accrual Period
                        <p-sortIcon field="SickAccrualPeriod" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="representative" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                    [options]="this.historySickPeriodFilterSelectItem" [filter]="true"
                                    (onChange)="filter($event.value)">
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- Hours Setting -->
                    <th pSortableColumn="Sick_HoursSetting">
                        SICK Current Setting
                        <p-sortIcon field="Sick_HoursSetting" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Rate -->
                    <th pSortableColumn="Sick_EarnedRate">
                        SICK Earned Rate
                        <p-sortIcon field="Sick_EarnedRate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Hours Earned -->
                    <th pSortableColumn="Sick_HoursEarned">
                        SICK Hours Earned
                        <p-sortIcon field="Sick_HoursEarned" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Hours Earned Override -->
                    <th pSortableColumn="Sick_HoursEarnedAdjust">
                        SICK Hours Earned Override
                        <p-sortIcon field="Sick_HoursEarnedAdjust" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Cost -->
                    <th pSortableColumn="Sick_EarnedCost">
                        SICK Earned Cost
                        <p-sortIcon field="Sick_EarnedCost" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Earned Cost Override -->
                    <th pSortableColumn="Sick_EarnedCostAdjust">
                        SICK Earned Cost Override
                        <p-sortIcon field="Sick_EarnedCostAdjust" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                    <!-- Taken -->
                    <th pSortableColumn="Sick_HoursTaken">
                        SICK Taken
                        <p-sortIcon field="Sick_HoursTaken" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="frozenbody" let-adjustment let-edit="editing" let-ri="rowIndex">
                <tr [pEditableRow]="adjustment" class="tabulator-row p-selectable-row"
                    data-id="row-1-{{ adjustment.Uniqueid }}"></tr>
            </ng-template>
            <ng-template #body let-adjustment let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="adjustment" data-id="row-{{ adjustment.Uniqueid }}">
                    <!-- Edit -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                        <button *ngIf="
                                                !editing &&
                                                (!editing_LA?.Uniqueid ||
                                                    !editing_LA?.Uniqueid ===
                                                        adjustment?.Uniqueid)
                                            " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(adjustment)" class="p-button-rounded p-button-text"
                            title="Edit"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave(adjustment)"
                            class="p-button-rounded p-button-text p-button-success"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(adjustment)"
                            class="p-button-rounded p-button-text p-button-danger"></button>
                    </td>
                    <!-- Status -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                        <a (click)="onStatusClick(adjustment)">
                            <div>
                                <ef-status-icon [status]="
                                                        adjustment?.Status
                                                            ?.StatusCode
                                                    " [message]="
                                                        adjustment?.Status
                                                            ?.Message
                                                    "></ef-status-icon>
                            </div>
                        </a>
                    </td>
                    <!-- Pay Period Start -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <span *ngIf="adjustment.PPS != null">
                            {{
                            moment(adjustment.PPS).format(
                            'MM/DD/YYYY'
                            )
                            }}
                        </span>
                    </td>
                    <!-- Pay Period End -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <span *ngIf="adjustment.PPE != null">
                            {{
                            moment(adjustment.PPE).format(
                            'MM/DD/YYYY'
                            )
                            }}
                        </span>
                    </td>
                    <!-- Name -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        <label [title]="adjustment.EmployeeName">{{
                            adjustment.EmployeeName
                            }}</label>
                    </td>
                    <!-- Vac Accrual Period -->
                    <td>
                        <label>{{
                            adjustment.VacAccrualPeriod
                            }}</label>
                    </td>
                    <!-- Hours Setting -->
                    <td>
                        <label>{{
                            adjustment.Vac_HoursSetting
                            }}</label>
                    </td>
                    <!-- Earned Rate -->
                    <td>
                        <label>{{
                            adjustment.Vac_EarnedRate
                            }}</label>
                    </td>
                    <!-- Hours Earned -->
                    <td>
                        <label>{{
                            adjustment.Vac_HoursEarned
                            }}</label>
                    </td>
                    <!-- Hours Earned Override -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        adjustment.Vac_HoursEarnedAdjust
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                adjustment.Vac_HoursEarnedAdjust
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Earned Cost -->
                    <td>
                        <label>{{
                            adjustment.Vac_EarnedCost
                            }}</label>
                    </td>
                    <!-- Earned Cost Override -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        adjustment.Vac_EarnedCostAdjust
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                adjustment.Vac_EarnedCostAdjust
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Taken -->
                    <td>
                        <label>{{
                            adjustment.Vac_HoursTaken
                            }}</label>
                    </td>

                    <td class="separator-cell"></td>

                    <!-- Sick Accrual Period -->
                    <td>
                        <label>{{
                            adjustment.SickAccrualPeriod
                            }}</label>
                    </td>
                    <!-- Hours Setting -->
                    <td>
                        <label>{{
                            adjustment.Sick_HoursSetting
                            }}</label>
                    </td>
                    <!-- Earned Rate -->
                    <td>
                        <label>{{
                            adjustment.Sick_EarnedRate
                            }}</label>
                    </td>
                    <!-- Hours Earned -->
                    <td>
                        <label>{{
                            adjustment.Sick_HoursEarned
                            }}</label>
                    </td>
                    <!-- Hours Earned Override -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        adjustment.Sick_HoursEarnedAdjust
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                adjustment.Sick_HoursEarnedAdjust
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Earned Cost -->
                    <td>
                        <label>{{
                            adjustment.Sick_EarnedCost
                            }}</label>
                    </td>
                    <!-- Earned Cost Override -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="
                                                        adjustment.Sick_EarnedCostAdjust
                                                    " />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                adjustment.Sick_EarnedCostAdjust
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Taken -->
                    <td>
                        <label>{{
                            adjustment.Sick_HoursTaken
                            }}</label>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </p-accordionTab>
    </p-accordion>
</div>
